// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3kPzw","symbol":"styles-module__symbol___1TWoT","total":"styles-module__total___xSxmP"};